import { Component, OnInit, EventEmitter, Output, ViewChildren, ElementRef, QueryList, Input, ViewChild } from '@angular/core';
import { IRalGroup, RalGroups, IRalColor, RalMap } from './ral-colors';

export interface IRalColorSelectedEvent {
    ralColor: IRalColor;
    isMatt: boolean;
}

@Component({
    selector: 'ral-colorpicker',
    templateUrl: './ral-colorpicker.component.html',
    styleUrls: ['./ral-colorpicker.component.scss']
})
export class RalColorpickerComponent implements OnInit {
    public ralGroups: IRalGroup[] = RalGroups;
    public ralMap: { [ral: number]: string } = RalMap;
    public selectedRalGroup: IRalGroup = RalGroups[0];
    public inputValue: string;
    public isInputValueValid: boolean = true;

    @Input()
    public allowMattGlossySelection: boolean = false;

    @Input()
    public isMatt: boolean = true;

    @Input()
    public isSlimMode: boolean = false;

    private _selectedRalColor: IRalColor;
    public get selectedRalColor(): IRalColor | number {
        return this._selectedRalColor;
    }

    @Input()
    public set selectedRalColor(newValue: IRalColor | number) {
        if (typeof newValue === 'number')
            this._selectedRalColor = { ral: newValue, color: this.ralMap[newValue] };
        else
            this._selectedRalColor = newValue;
    }

    @ViewChildren("ralGroups")
    public ralGroupElements: QueryList<ElementRef>;

    @ViewChild("numberInput")
    public numberInput: ElementRef;

    public get selectedRalGroupIndex(): number {
        return this.ralGroups.indexOf(this.selectedRalGroup);
    }

    public get ralGroupHighlightTop(): string {
        // TODO: implement this
        return "";
    }

    @Output()
    public ralColorSelected = new EventEmitter<IRalColorSelectedEvent>();

    constructor() {}

    public ngOnInit() {}

    public setSelectedGroup(ralGroup: IRalGroup) {
        this.selectedRalGroup = ralGroup;
    }

    // source: https://24ways.org/2010/calculating-color-contrast/
    public contrastColor(color: string): string {
        const colorNumber = color.substr(1);

        const r = parseInt(colorNumber.substr(0, 2), 16);
        const g = parseInt(colorNumber.substr(2, 2), 16);
        const b = parseInt(colorNumber.substr(4, 2), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#444' : '#eee';
    }

    public selectRalColor(ralColor: IRalColor) {
        this.selectedRalColor = ralColor;
        this.inputValue = ralColor.ral.toString();
        this.ralColorSelected.emit({ ralColor, isMatt: this.isMatt });
    }

    public setIsMatt(newValue: boolean) {
        this.isMatt = newValue;
        if (this._selectedRalColor === undefined)
            this._selectedRalColor = { ral: 1000, color: this.ralMap[1000] };

        this.ralColorSelected.emit({ ralColor: this._selectedRalColor, isMatt: this.isMatt });
    }

    public setRalColorFromInput() {
        const ralColorId = (this.numberInput.nativeElement as HTMLInputElement).value;
        const ralCssColor = this.ralMap[ralColorId];
        if (ralCssColor !== undefined)
            this.selectRalColor({ ral: Number(ralColorId), color: ralCssColor });
    }

    public numberInput_keyDown(event: KeyboardEvent) {
        if (event.keyCode === 13)
            this.setRalColorFromInput();
    }

    public numberInput_keyUp(event: Event) {
        const inputValue: string = (event.target as HTMLInputElement).value;
        if (inputValue === '')
            this.isInputValueValid = true;

        const ralCssColor = this.ralMap[inputValue];
        this.isInputValueValid = ralCssColor !== undefined;
    }

    /** The width of ral colors is determined by the group size. */
    public getColorWidth(ralGroup: IRalGroup): string {
        const groupSize = ralGroup.items.length;

        if (this.isSlimMode) {
            if (groupSize > 20)
                return '22%';
            else
                return groupSize < 15 ? '47%' : '29%';
        } else {
            if (groupSize > 20)
                return groupSize > 30 ? '17%' : '22%';
            else
                return groupSize < 15 ? '47%' : '29%';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/ral-colorpicker/ral-colorpicker.component.ts